var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('modal',{attrs:{"options":{close: true}},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"title"},[_vm._v("Calendario")]),_c('div',{staticClass:"body"},[_c('calendario',{attrs:{"options":_vm.calendario_config,"eventos":_vm.eventos}})],1),_c('div',{staticClass:"footer"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }